import { useEffect } from "react";
import { styled } from "styled-components";

import { AUTH_WIDGET_ID } from "common/constants/authWidgetId";
import { onAuthWidgetLoad } from "common/utilities/onAuthWidgetLoad";

const StyledAuthWidgetWrapper = styled.div`
  display: block !important;
  position: relative;
  padding-top: 6rem;
  height: 100%;

  .aw-back-button {
    top: 86px;
    left: -12px;
  }

  meter {
    border-width: 0;
  }
`;

export const AuthenticationModal = () => {
  useEffect(() => onAuthWidgetLoad((authWidget) => authWidget.render()), []);

  return <StyledAuthWidgetWrapper data-test-id="authentication-modal" id={AUTH_WIDGET_ID}></StyledAuthWidgetWrapper>;
};
